import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectOrganizationsSelected = createSelector(
  [
    (store: RootState) => store.userProfileOrganization.selectedOrganizations,
    (store: RootState) => store.userProfileOrganization.selectedSearchText,
  ],
  (selectedOrganizations, selectedSearchText) => {
    const data = selectedOrganizations.filter(
      ({ name }) => {
        // Filtro por nombre y código 
        if (
          selectedSearchText
          && !name?.toLowerCase().includes(selectedSearchText?.toLowerCase().trim())
        ) {
          return false;
        }
        return true;
      }
    );
    const orderedList = [...data].sort((a, b) => {
      if (a.name && b.name && a.name < b.name) {
        return -1;
      }
      if (a.name && b.name && a.name > b.name) {
        return 1;
      }
      return 0;
    });

    return orderedList;
  }
);

